const packages = [
  {
    icon: 'ri-compass-3-line',
    badge: 'Пакет 1',
    title: 'SMM-Стратегия',
    subtitle: 'Фундамент',
    desc: 'Для тех, кто хочет делегировать маркетинговую стратегию и аналитику, но вести соцсети самостоятельно или силами штатного помощника.',
    items: [
      'Аналитика: Исследование ЦА, конкурентов и Карта персонажей',
      'Архитектура: Подбор площадок и создание CJM (пути клиента)',
      'Контент-план: Рубрикатор и детальный план на 1 месяц (20–25 тем)',
      'AI-Инструкция: Список промптов и ИИ-инструментов под ваш бренд',
    ],
    result: 'Чёткая дорожная карта: что и зачем публиковать, чтобы были продажи.',
    highlight: false,
  },
  {
    icon: 'ri-rocket-2-line',
    badge: 'Пакет 2',
    title: 'Нейро-Старт',
    subtitle: 'Стратегия + Контент',
    desc: 'Оптимально для экспертов и малого бизнеса. Мы создаём систему и запускаем её.',
    items: [
      'Всё из пакета «SMM-Стратегия»',
      'Упаковка: Дизайн и настройка 2–3 ключевых соцсетей',
      'Производство: 12 постов (текст + визуал) и 8 сценариев для Reels/Shorts',
      'Запуск: Публикация контента в течение первого месяца',
    ],
    result: 'Готовые профессионально оформленные соцсети с первым целевым трафиком.',
    highlight: true,
  },
  {
    icon: 'ri-building-4-line',
    badge: 'Пакет 3',
    title: 'Системное управление',
    subtitle: 'Ваш отдел маркетинга',
    desc: 'Полное делегирование всех процессов. Мы становимся вашим бизнес-партнёром.',
    items: [
      'Полное ведение: Публикации, сторис, Reels ежедневно',
      'AI-Комьюнити: Модерация комментариев и обработка заявок в Директе',
      'Трафик: Работа с блогерами и посевы (рекламный бюджет — отдельно)',
      'Аналитика: Еженедельные отчёты по ROI и стоимости лида',
    ],
    result: 'Стабильный рост лояльной аудитории и системный поток заявок.',
    highlight: false,
  },
];

export default function SMMPackages() {
  return (
    <section className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-stack-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Тарифы и пакеты
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Пакеты комплексного SMM-продвижения
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {packages.map((pkg) => (
            <div
              key={pkg.title}
              className={`relative rounded-2xl overflow-hidden flex flex-col ${
                pkg.highlight
                  ? 'bg-[#1A2B4C] border-2 border-[#C5A880]'
                  : 'bg-white border border-[#E8DDD0]'
              }`}
            >
              {pkg.highlight && (
                <div className="text-center bg-[#C5A880] py-2">
                  <span className="text-white text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
                    Популярный выбор
                  </span>
                </div>
              )}
              <div className="p-5 sm:p-8 flex flex-col flex-1">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                  pkg.highlight ? 'bg-[#C5A880]/20' : 'bg-[#1A2B4C]/08'
                }`}>
                  <i className={`${pkg.icon} text-2xl ${pkg.highlight ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}></i>
                </div>
                <span className="text-xs font-bold font-['Montserrat'] uppercase tracking-wider mb-1 text-[#C5A880]">{pkg.badge}</span>
                <h3 className={`text-xl sm:text-2xl font-['Playfair_Display'] font-bold mb-1 leading-snug ${
                  pkg.highlight ? 'text-white' : 'text-[#1A2B4C]'
                }`}>{pkg.title}</h3>
                <p className="text-sm font-semibold font-['Montserrat'] mb-3 text-[#C5A880]">{pkg.subtitle}</p>
                <p className={`text-xs sm:text-sm leading-relaxed font-['Montserrat'] mb-5 ${
                  pkg.highlight ? 'text-white/70' : 'text-gray-500'
                }`}>{pkg.desc}</p>

                <ul className="space-y-2.5 mb-6 flex-1">
                  {pkg.items.map((item) => (
                    <li key={item} className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-sm font-bold text-[#C5A880]"></i>
                      </div>
                      <span className={`text-xs leading-relaxed font-['Montserrat'] ${
                        pkg.highlight ? 'text-white/80' : 'text-gray-600'
                      }`}>{item}</span>
                    </li>
                  ))}
                </ul>

                <div className={`border-t pt-4 mt-auto ${
                  pkg.highlight ? 'border-white/15' : 'border-gray-100'
                }`}>
                  <div className="flex items-start gap-2 mb-4">
                    <i className="ri-award-line text-sm flex-shrink-0 mt-0.5 text-[#C5A880]"></i>
                    <p className={`text-xs leading-relaxed font-['Montserrat'] italic ${
                      pkg.highlight ? 'text-white/60' : 'text-gray-500'
                    }`}>{pkg.result}</p>
                  </div>
                  <a
                    href="#smm-form"
                    className={`block w-full text-center py-3 rounded-xl text-sm font-semibold font-['Montserrat'] transition-all duration-300 cursor-pointer whitespace-nowrap ${
                      pkg.highlight
                        ? 'bg-[#C5A880] hover:bg-[#B39770] text-white'
                        : 'bg-[#1A2B4C] hover:bg-[#253D6B] text-white'
                    }`}
                  >
                    Выбрать пакет
                    <i className="ri-arrow-right-line ml-1.5"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
